import { BaseLayout } from "./BaseLayout";

export class StandardContentLayout extends BaseLayout {
    private static layout = require("./Templates/Standard.html").default;

    apply(): void {
        this.setContentLayout(StandardContentLayout.layout);
    }
}
